export default __webpack_public_path__ + "static/media/scenario-c-home.f024847d.png";